import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Story from '../../components/Story'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'
import Slider from 'react-slick';

const Milestone = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [ourStoryWidget, setOurStoryWidget] = useState()
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [story, setStory] = useState([])
  const apiUrl = apiBaseUrl+`aboutpage`;


  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setOurStoryWidget(res.data.storywidget)
      setStory(res.data.milestone)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  const milestonesettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],          
  };  

  return (
    <>
    <Header/>
    
    { loading && (<Loader />)}    

    <div id="story" className="container vertical-gap"><hr /></div>

    <section className="section-content-block pb-170">
        <div className="container">
          <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                  <div className="about-us-intro">
                    <p className="blue">{ourStoryWidget?.name}</p>
                    <h2 className="heading">{ourStoryWidget?.heading}</h2>
                    <p className='col-lg-offset-2 col-lg-8 col-sm-12'>{ourStoryWidget?.description}</p>
                  </div>                            
              </div> 
          </div>
        {(story.length > 0) && (
          <div className="row">
            <div className="story-carousel clients col-sm-12">
              <Slider {...milestonesettings}>
                {story.map((item, index)=>{
                  return(
                    <Story
                      key={index}
                      prm={{
                        name: item?.name,
                        description: item?.description
                      }}
                    />
                  )
                })}

              </Slider>
            </div>
          </div>
        )}
        </div> 
    </section>

    <section className="mb-100">
      <div className="container">
        <div className="row">
            <img src="/images/storyline.jpg" alt="" /> 
        </div>      
      </div>
    </section>

    <Footer/>
    </>
  )
}

export default Milestone